import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-contract-info" }


import ListRow from "@/components/common/list/ListRow.vue";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardContractInfo',
  props: {
    companyInvoice: {}
  },
  setup(__props: any) {

const props = __props;



const columns = [
  {
    header: "契約プラン",
    text: props.companyInvoice.labels.contract_plan,
  },
  {
    header: "年次契約",
    text: `${props.companyInvoice.annually_contract_count.toLocaleString()} ID`,
  },
  {
    header: "年次契約備考",
    text: props.companyInvoice.annually_contract_memo || '-',
  },
  {
    header: "月次契約",
    text: `${props.companyInvoice.monthly_contract_count.toLocaleString()} ID`,
  },
  {
    header: "月次契約備考",
    text: props.companyInvoice.monthly_contract_memo || '-'
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListRow, {
      columns: columns,
      vertical: "",
      "half-gap": ""
    })
  ]))
}
}

})